.ae{aspect-ratio:1/1;}